{
  "navigation-back-button": {
    "text": {
      "back": "Zurück",
      "home-page": "Startseite"
    }
  }
}
